import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const VotingTabs = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridGap: defaultTheme.spacing.xs,
    marginBottom: defaultTheme.spacing.xxl,
  }),
);

export const VotingTabsButton = styled.button((props: { isActive: boolean }) =>
  mq({
    display: 'flex',
    flexDirection: ['column', 'column', 'row', 'row'],
    justifyContent: 'center',
    alignItems: 'center',
    color: props.isActive ? defaultTheme.text.white : defaultTheme.text.default,
    fontSize: defaultTheme.font.size.s,
    fontWeight: props.isActive ? 'bold' : 'normal',
    lineHeight: defaultTheme.font.height.m,
    backgroundColor: props.isActive
      ? defaultTheme.background.secondary
      : defaultTheme.background.white,
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: props.isActive
      ? defaultTheme.border.color.black
      : defaultTheme.border.color.mediumGray,
    borderRadius: defaultTheme.border.radius.s,
    height: '46px',
    '& > span::after': {
      content: ['normal', 'normal', '"・"', '"・"'],
    },
  }),
);

export const HeaderWrapper = styled.div(() =>
  mq({ marginTop: defaultTheme.spacing.xxl }),
);

export const HeaderBox = styled.div(() =>
  mq({
    border: `2px solid ${defaultTheme.border.color.mediumLightGray}`,
    padding: defaultTheme.spacing.xxl,
    marginTop: defaultTheme.spacing.l,
    '&:first-of-type': {
      marginTop: `-${defaultTheme.spacing.s}`,
    },
  }),
);

export const MultiType = styled.dl(() =>
  mq({
    marginTop: defaultTheme.spacing.xxl,
    '& > dt': {
      display: 'flex',
      alignItems: 'center',
      fontWeight: 'bold',
      margin: `${defaultTheme.spacing.xxl} 0 ${defaultTheme.spacing.l}`,
      '& img': {
        marginRight: defaultTheme.spacing.s,
      },
    },
    '& > dd': {
      fontSize: defaultTheme.font.size.s,
      lineHeight: defaultTheme.font.height.l,
    },
  }),
);

export const Hr = styled.hr(() =>
  mq({
    borderColor: defaultTheme.border.color.mediumLightGray,
    margin: [
      `${defaultTheme.spacing.xxl} 0`,
      `${defaultTheme.spacing.xxl} 0`,
      '32px 0',
      '32px 0',
    ],
  }),
);

export const HowtoVote = styled.dl(() =>
  mq({
    marginTop: '32px',
    '& > dt': {
      fontSize: defaultTheme.font.size.m,
      fontWeight: 'bold',
      margin: `32px 0 ${defaultTheme.spacing.l}`,
    },
  }),
);

const HowtoImageBase = styled.div(() =>
  mq({
    margin: `${defaultTheme.spacing.l} auto`,
    '& img': {
      width: '100%',
      height: 'auto',
    },
  }),
);

export const HowtoImageSP = styled(HowtoImageBase)(() =>
  mq({
    width: ['100%', '100%', '400px', '400px'],
    maxWidth: '400px',
  }),
);

export const HowtoImagePC = styled(HowtoImageBase)(() =>
  mq({
    width: ['100%', '100%', '560px', '560px'],
    maxWidth: '560px',
  }),
);

export const MultiHeader = styled.div(() =>
  mq({
    marginBottom: '32px',
  }),
);

export const ContentInnerBox = styled.div(() =>
  mq({
    border: `2px solid ${defaultTheme.border.color.mediumLightGray}`,
    padding: defaultTheme.spacing.xxl,
    margin: `${defaultTheme.spacing.xxl} 0 ${defaultTheme.spacing.l}`,
  }),
);
